import modalTemp from './modalTemp.vue'
export default modalTemp


// WEBPACK FOOTER //
// ./src/components/modal/index.js